import { render, staticRenderFns } from "./ControlListTable.vue?vue&type=template&id=2006c855&"
import script from "./ControlListTable.vue?vue&type=script&lang=js&"
export * from "./ControlListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports